import CouponCategory01 from '@/assets/svg/icon_discount_shop.svg'
import CouponCategory02 from '@/assets/svg/icon_discount_food.svg'
import CouponCategory03 from '@/assets/svg/icon_discount_car.svg'
import CouponCategory04 from '@/assets/svg/icon_discount_hotel.svg'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import { Link } from 'react-router-dom'

const COUPON_TICKET_IMAGE =
  '29ab0a358f5d9c1e48c4e71c71e57d1f.png'

export const COUPON_CATEGORY_CARDS = [
  {
    id: 'shopping',
    available: true,
    icon: CouponCategory01,
    titleKey: 'coupon.categories.shopping.title',
    descriptionKey: 'coupon.categories.shopping.description',
    coupons: [
      {
        image: '3cb0586a36533ca40d88b0b8c9f54c4a.png',
        nameKey: 'coupon.categories.shopping.coupons.donQuijote.name',
        offerKey: 'coupon.categories.shopping.coupons.donQuijote.offer',
      },
      {
        image: '75cdbfb08f910975b747b5878608220f.png',
        nameKey: 'coupon.categories.shopping.coupons.departmentStore.name',
        offerKey: 'coupon.categories.shopping.coupons.departmentStore.offer',
      },
    ],
  },
  {
    id: 'food',
    available: false,
    icon: CouponCategory02,
    titleKey: 'coupon.categories.food.title',
    descriptionKey: 'coupon.categories.food.description',
    coupons: [
      {
        image: 'c921e804d426e4853308ece6567754ce.png',
        nameKey: 'coupon.categories.food.coupons.ramen.name',
        offerKey: 'coupon.categories.food.coupons.ramen.offer',
      },
      {
        image: 'a4f023055962412521628f3bfe826a47.png',
        nameKey: 'coupon.categories.food.coupons.seafood.name',
        offerKey: 'coupon.categories.food.coupons.seafood.offer',
      },
    ],
  },
  {
    id: 'transport',
    available: false,
    icon: CouponCategory03,
    titleKey: 'coupon.categories.transport.title',
    descriptionKey: 'coupon.categories.transport.description',
    coupons: [
      {
        image: '3d88b4a9abad0bfab19e1699c1d9c289.png',
        nameKey: 'coupon.categories.transport.coupons.airportBus.name',
        offerKey: 'coupon.categories.transport.coupons.airportBus.offer',
      },
      {
        image: 'e2b5383d302a0ef0329454ad93dcb55a.png',
        nameKey: 'coupon.categories.transport.coupons.railPass.name',
        offerKey: 'coupon.categories.transport.coupons.railPass.offer',
      },
    ],
  },
  {
    id: 'accommodation',
    available: false,
    icon: CouponCategory04,
    titleKey: 'coupon.categories.accommodation.title',
    descriptionKey: 'coupon.categories.accommodation.description',
    coupons: [
      {
        image: '5aa65a3b712078bf4ca0d5b7166ae7d7.png',
        nameKey: 'coupon.categories.accommodation.coupons.attraction.name',
        offerKey: 'coupon.categories.accommodation.coupons.attraction.offer',
      },
      {
        image: '3cb6fb949a08f1abdcc9297dd9572bcb.png',
        nameKey: 'coupon.categories.accommodation.coupons.hotel.name',
        offerKey: 'coupon.categories.accommodation.coupons.hotel.offer',
      },
    ],
  },
] as const

const CouponCategories = () => (
  <section className="w-full bg-[#FAFAFA] pb-[96px]">
    <div className="mx-auto grid w-[1200px] grid-cols-2 gap-[32px]">
      {COUPON_CATEGORY_CARDS.map((category) => {
        const CategoryIcon = category.icon

        return (
          <article
            key={category.id}
            className="rounded-[20px] border border-[#E8E8E8] bg-white px-[24px] py-[32px] transition-[transform,box-shadow] duration-300 hover:shadow-[0_14px_36px_rgba(50,139,248,0.1)]"
          >
            <header className="flex items-center">
              <span className="flex h-[96px] w-[96px] items-center justify-center">
                <img src={CategoryIcon} alt="" className="w-full h-full" />
              </span>
              <div className="ml-[24px] min-w-0 flex-1">
                <LangText
                  lngKey={category.titleKey}
                  className="block text-[32px] font-bold leading-[38px] text-[#333] font-smiley-sans"
                />
                <LangText
                  lngKey={category.descriptionKey}
                  className="mt-[16px] block text-[20px] leading-[28px] text-[#666]"
                />
              </div>
              {category.available ? (
                <Link
                  to="/coupon-list"
                  className="rounded-full bg-[#fff] px-[24px] text-[16px] leading-[38px] text-primary transition-colors hover:bg-secondary border border-[#328BF8]/40"
                >
                  <LangText lngKey="coupon.categories.viewMore" />
                </Link>
              ) : (
                <span className="cursor-not-allowed rounded-full bg-[#F2F2F2] px-[24px] text-[16px] leading-[38px] text-[#AAAAAA]">
                  <LangText lngKey="common.status.stayTuned" />
                </span>
              )}
            </header>

            <div className="mt-[18px] grid grid-cols-2 gap-[16px]">
              {category.coupons.map((coupon) => (
                <div key={coupon.nameKey} className="group overflow-hidden rounded-[16px]">
                  <div className="h-[132px] overflow-hidden rounded-[16px] bg-[#F2F2F2]">
                    {coupon.image ? (
                      <img
                        src={preFixImgUrl(coupon.image)}
                        alt=""
                        className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
                        draggable={false}
                      />
                    ) : null}
                  </div>

                  <div className="relative z-[1] mt-[-14px] h-[125px]">
                    <img
                      src={preFixImgUrl(COUPON_TICKET_IMAGE)}
                      alt=""
                      className="object-fill absolute inset-0 w-full h-full"
                      draggable={false}
                    />
                    <div className="relative z-[1] flex h-full flex-col items-center pt-[20px] text-center">
                      <LangText
                        lngKey={coupon.nameKey}
                        className="text-[16px] font-medium leading-[32px] text-white"
                      />
                      <LangText
                        lngKey={coupon.offerKey}
                        className="mt-[4px] text-[24px] font-medium leading-[34px] text-[#D07E26]"
                      />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </article>
        )
      })}
    </div>
  </section>
)

export default CouponCategories
